"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const styled_1 = __importDefault(require("../utils/styled"));
const DataTable_styled_1 = require("../DataTable/DataTable.styled");
exports.Container = styled_1.default.div `
  display: grid;

  /**
   * The columns are: type, name, right icon, and caret for icons
   */
  grid-template-columns: ${({ hasIcon }) => hasIcon
    ? `${DataTable_styled_1.dataTableActionContainerSize}px auto ${DataTable_styled_1.dataTableActionContainerSize}px ${DataTable_styled_1.dataTableActionContainerSize}px`
    : `auto ${DataTable_styled_1.dataTableActionContainerSize}px ${DataTable_styled_1.dataTableActionContainerSize}px`};
  width: calc(100% + ${({ theme }) => theme.space.content * 2}px);
  height: 100%;
  margin: 0 -${({ theme }) => theme.space.content}px;
  align-items: center;
  padding-left: ${({ hasIcon, theme }) => (hasIcon ? 0 : theme.space.content)}px;
  grid-column: 1 / span 2;
`;
exports.TitleContainer = styled_1.default.div `
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: pre;
`;
exports.GhostTitleContainer = styled_1.default.div `
  position: absolute;
  top: 0;
  left: ${({ theme, hasIcon }) => (hasIcon ? DataTable_styled_1.dataTableActionContainerSize : theme.space.content)}px;
  visibility: hidden;
  pointer-events: none;
  white-space: pre;
  max-width: 100%;
`;
exports.ActionsContainer = styled_1.default.div `
  display: flex;
  align-items: stretch;
  margin: auto;
  width: 100%;
  height: 100%;
`;
//# sourceMappingURL=DataTableHeader.styled.js.map